﻿(() => {
  const root = document.documentElement;
  function initLeafTrail() {
    const layer = document.querySelector('[data-aepinbh-leaf-layer]');
    if (!layer || window.matchMedia('(max-width: 749px)').matches) return;
    const density = Number(layer.dataset.density || 5);
    const opacity = Number(layer.dataset.opacity || 0.36);
    let lastLeafAt = 0;
    window.addEventListener('pointermove', (event) => {
      const now = Date.now();
      const interval = Math.max(90, 260 - density * 22);
      if (now - lastLeafAt < interval) return;
      lastLeafAt = now;
      const leaf = document.createElement('span');
      leaf.className = 'aepinbh-cursor-leaf';
      const size = 8 + Math.random() * 10;
      const driftX = (Math.random() - 0.5) * 88;
      const driftY = 58 + Math.random() * 90;
      const rotate = 90 + Math.random() * 260;
      leaf.style.left = `${event.clientX - size / 2}px`;
      leaf.style.top = `${event.clientY - size / 2}px`;
      leaf.style.width = `${size}px`;
      leaf.style.height = `${size * 1.45}px`;
      leaf.style.setProperty('--leaf-x', `${driftX}px`);
      leaf.style.setProperty('--leaf-y', `${driftY}px`);
      leaf.style.setProperty('--leaf-rotate', `${rotate}deg`);
      leaf.style.setProperty('--leaf-opacity', `${opacity}`);
      leaf.style.setProperty('--leaf-duration', `${2.2 + Math.random() * 1.4}s`);
      layer.appendChild(leaf);
      window.setTimeout(() => leaf.remove(), 4200);
    }, { passive: true });
  }
  function initPopup() {
    const popup = document.querySelector('[data-aepinbh-popup]');
    if (!popup) return;
    const frequency = popup.dataset.frequency || 'session';
    const key = 'aepinbh-promo-popup-dismissed';
    const stored = frequency === 'always' ? null : window.localStorage.getItem(key);
    const now = Date.now();
    if (frequency === 'session' && window.sessionStorage.getItem(key)) return;
    if (frequency === 'day' && stored && now - Number(stored) < 86400000) return;
    const close = () => {
      popup.hidden = true;
      if (frequency === 'session') window.sessionStorage.setItem(key, String(now));
      if (frequency === 'day') window.localStorage.setItem(key, String(now));
    };
    window.setTimeout(() => { popup.hidden = false; }, Number(popup.dataset.delay || 650));
    popup.querySelector('[data-aepinbh-popup-close]')?.addEventListener('click', close);
    popup.addEventListener('click', (event) => { if (event.target === popup) close(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !popup.hidden) close(); });
  }
  document.addEventListener('DOMContentLoaded', () => {
    root.classList.add('aepinbh-enhanced');
    initLeafTrail();
    initPopup();
  });
})();
